const subsid = {
  FreemiumID: 'd9ca81fd-d371-48f2-9c5c-a75ec7f9e55e',
  BasicID: 'e84734a3-2b65-410c-b108-7cd81f7ec466',
  RegularID: 'd4150b83-b928-44e1-a9b0-b0d16d85f7c6',
  PremiumID: '40ffadad-0edd-4eb0-b5f7-db9b272bb662',
  PremiumPlusID: 'b745d359-8fea-4f52-820f-f9687abc7297',
};

export default subsid;
